const { sortBy } = require('lodash');

const { NONE_DROPDOWN_VALUES } = require('@commons/constants/dropdown');

export const getUniqueGroupsOfStores = (stores) => {
  const noneValue = NONE_DROPDOWN_VALUES().MASCULINE;

  const storeUniqueGroupsKeyById = stores.reduce(
    (acc, { groups }) => {
      groups.forEach((group) => {
        if (!acc[group.id]) {
          acc[group.id] = group;
        }

        return acc;
      });

      return acc;
    },
    { [noneValue.id]: noneValue },
  );

  return sortBy(Object.values(storeUniqueGroupsKeyById), 'name');
};
